var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVr = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.714 4H2.033C1.466 4 1 4.466 1 5.033v9.506c0 .567.466 1.032 1.033 1.032h4.464c.557 0 1.043-.354 1.215-.88l1.063-3.18c.395-1.173 2.045-1.173 2.44 0l1.063 3.18c.172.526.668.88 1.225.88h4.464c.567 0 1.033-.465 1.033-1.032V5.286C19 4.577 18.423 4 17.714 4M6.477 11.471c-1.782.891-3.553-.87-2.663-2.662.152-.314.405-.567.72-.719 1.781-.89 3.553.87 2.662 2.662a1.64 1.64 0 0 1-.72.72m9 0c-1.782.891-3.553-.87-2.663-2.662.152-.314.405-.567.72-.719 1.781-.89 3.553.87 2.662 2.662a1.64 1.64 0 0 1-.72.72"
  })));
};
export { SvgVr as ReactComponent };